export default {
  // 모드
  "common.mode.auto": "자동 모드（자가 발전 이용）",
  "common.mode.economy": "경제 모드",
  "common.mode.exigency": "비상 모드",

  // 기기
  "common.grid": "전력망",
  "common.evChargers": "전기차 충전기（복수）",
  "common.evCharger": "전기차 충전기",
  "common.pv": "태양광 발전（PV）",
  "common.inverter": "인버터（전압 변환 장치）",
  "common.pcs": "인버터＋배터리",
  "common.terminal": "단말 장치",
  "common.airc": "에어컨（AC）",
  "common.engine": "엔진",
  "common.battery": "배터리",
  "common.metter": "전력량계",
  "common.other": "기타",
  "common.power": "전력",
  "common.powerTotal": "총 전력",
  "common.voltage": "전압",
  "common.electricity": "전기",
  "common.current": "전류",
  "common.homeUsage": "총 가정 부하",
  "common.battery.power": "배터리 전력",

  // 데이터
  "common.noDataAvailable": "현재 데이터를 사용할 수 없습니다~",
  "common.tips": "팁",
  "common.reset": "리셋（초기화）",
  "common.currencyUnit": "¥（위안）",
  "common.submiting": "전송 중... 잠시만 기다려 주세요...",
  "common.close": "닫기",
  "common.from": "부터",
  "common.useIn": "까지",
  "common.energyPercent": "에너지 이용률",
  "common.dataFlow": "데이터 흐름",
  "common.getDataIng": "데이터 가져오는 중... 잠시만 기다려 주세요...",
  "common.pageLoading": "페이지 로딩 중... 잠시만 기다려 주세요...",
  "common.reseting": "페이지 리셋 중... 잠시만 기다려 주세요...",
  "common.save": "저장",
  "common.onlyNumberTips": "숫자만 입력할 수 있습니다",
  "common.offline": "오프라인",
  "common.online": "온라인",
  "common.fault": "오류（문제）",
  "common.charge": "충전（배터리）",
  "common.discharge": "방전（배터리 전력 사용）",
  "common.buy": "구매",
  "common.sell": "판매",
  "common.loadingInfo": "로딩 중... 잠시만 기다려 주세요...",

  // 일반 기능
  "common.moreFeatures": "추가 기능",
  "common.confirm": "확인",
  "common.saveing": "저장 중... 잠시만 기다려 주세요...",
  "common.searchPlacholder": "검색 키워드를 입력하세요",
  "common.iSee": "이해했습니다",
  "common.pageErrorTips1": "오ops, 페이지에 오류가 발생했습니다~",
  "common.pageErrorTips2": "페이지를 새로고침하거나 지원팀에 문의하세요~",
  "common.refresh": "새로고침",
  "common.backToHome": "홈페이지로 돌아가기",
  "common.checkTips": "검사 중... 잠시만 기다려 주세요...",
  "common.back": "뒤로가기",
  "common.cancel": "취소（삭제）",
  "common.optional": "선택 사항（필수 아님）",
  "common.required": "필수 입력 항목",
  "common.status": "상태",
  "common.statusNoDelete": "삭제되지 않음",
  "common.statusDelete": "삭제됨",
  "common.submit": "전송",
  "common.disable": "비활성화",
  "common.enable": "활성화",
  "common.year": "년",
  "common.month": "월",
  "common.day": "일",
  "common.version": "버전:",
  "common.backHome": "홈페이지로 돌아가기",
  "common.backHomeSorry": "죄송합니다, 이 페이지는 무효입니다",
  "common.requestTips1": "데이터 가져오는 중이므로 다시 전송하지 마세요",
  "common.requestTips2": "시스템 알림",
  "common.requestTips3": "로그인 세션이 만료되었습니다, 다시 로그인하세요",
  "common.requestTips4": "다시 로그인",
  "common.requestTips5": "로그인이 무효이거나 세션이 만료되었습니다, 다시 로그인하세요.",
  "common.requestTips6": "서버 오류가 발생했습니다. 나중에 다시 시도해 주세요.",
  "common.requestTips7": "시스템 요청 시간 초과",
  "common.requestTips8": "시스템 인터페이스",
  "common.requestTips9": "오류",
  "common.iknow": "이해했습니다",
  "common.logoutSuccess": "로그아웃 성공",
  
  // 자세한 정보 섹션
  "common.knowMore.title": "자세한 정보는 Beineng에 문의하세요",
  "common.knowMore.email": "문의 이메일",
  "common.knowMore.phone": "문의 전화번호",
  "common.knowMore.wechat": "문의 위챗",
  "common.knowMore.website": "공식 웹사이트 주소",
  "common.knowMore.address": "문의 주소",
  "common.knowMore.addressDetail": "광동성 동관시 황강진 황우포촌 청계8로 5동 1301호 1205실",
  
  // 로컬 연결
  "common.localConnection": "로컬 연결",
  "common.operateInApp": "앱 내에서 작업을 실행하세요!",
  
  "common.enbleStaus": "활성화 상태",
  "common.battery.status": "충전 안 함, 방전 안 함",

  // 계정 관련
  "account.forgetThePassword": "비밀번호를 잊으셨습니까",
  "account.logInDirectly": "직접 로그인",
  "account.tips1": "페이지 이동 중... 잠시만 기다려 주세요...",
  "account.tips2": "먼저 이용 약관을 읽고 동의하세요!",
  "account.autoLogin": "자동 로그인",
  "account.userLogin": "사용자 로그인",
  "account.registerTips": "계정이 없으신가요? 회원가입하려면 여기를 클릭하세요",
  "account.userEmail": "사용자명 / 이메일",
  "account.userEmailTips": "사용자명 또는 이메일을 입력하세요",
  "account.password": "비밀번호",
  "account.passwordTips": "비밀번호를 입력하세요",
  "account.submit": "전송",
  "account.submitTips": "전송 중... 잠시만 기다려 주세요...",
  "account.otherLoginTips": "또는 다른 로그인 방식을 선택하세요",
  "account.userRegistration": "사용자 회원가입",
  "account.userName": "사용자명",
  "account.userNameTips": "사용자명을 입력하세요",
  "account.emailTips1": "이메일 주소를 입력하세요",
  "account.emailTips2": "유효하지 않은 이메일 형식",
  "account.phone": "전화",
  "account.phoneTips1": "전화번호를 입력하세요",
  "account.phoneTips2": "유효하지 않은 전화번호",
  "account.phoneTips3": "전화번호를 입력하세요",
  "account.passwordTips1": "비밀번호를 입력하세요（6-30자）",
  "account.passwordTips2": "유효하지 않은 비밀번호 형식: 비밀번호는 영문자, 숫자, 밑줄(_), 하이픈(-) 및 점(.)을 포함해야 하며, 길이는 6-12자입니다",
  "account.passwordTips3": "입력한 두 개의 비밀번호가 일치하지 않습니다, 확인 후 다시 입력하세요!",
  "account.passwordTips4": "비밀번호를 입력하세요: 비밀번호는 영문자, 숫자, 밑줄(_), 하이픈(-) 및 점(.)을 포함해야 합니다",
  "account.passwordTips5": "비밀번호 확인",
  "account.passwordTips6": "비밀번호를 확인하기 위해 입력하세요",
  "account.passwordTips7": "입력한 두 개의 비밀번호가 일치하지 않습니다, 확인 후 다시 입력하세요!",
  "account.passwordTips8": "비밀번호를 확인하기 위해 입력하세요",
  "account.passwordTips9": "축하합니다, 회원가입에 성공했습니다!",
  "account.passwordTips10": "귀하의 사용자명은:",
  "account.emailIs": "귀하의 이메일은:",
  "account.goToLoginPage": "s초 후 자동으로 로그인 페이지로 이동합니다",
  "account.goLogin": "로그인",
  "account.goRegister": "회원가입",
  "account.loginSuccess": "로그인 성공",
  "account.email": "이메일",
  "account.sologn": "귀하를 위해 특별히 설계된 통합 에너지 플랫폼을 제공합니다",
  "account.pleaseAgree": "이용 약관을 읽고 동의합니다",
  "userAgreement.privacyPolicy": "개인정보 처리방침",

  // 인증 코드 관련
  "account.code": "인증 코드",
  "account.codeTips": "인증 코드를 입력하세요",
  "account.codeTips2": "유효하지 않은 인증 코드",

    "account.inviteCodeTips": "초대 코드를 입력해주세요",
    "account.inviteCodeHint": "초대 코드를 받으려면 설치 기사 또는 운영 유지보수 담당자에게 문의하세요",
  // 비밀번호 변경 및 복구
  "account.modifyPasswordByAccount": "계정을 통해 비밀번호 변경",
  "account.modifyPasswordByEmail": "이메일을 통해 비밀번호 변경",
  "account.getPasswordByAccount": "계정을 통해 비밀번호 가져오기",
  "account.getPasswordByEmail": "이메일을 통해 비밀번호 가져오기",

  "account.sendEmailTips": "인증 코드가 이메일로 전송되었습니다, 확인하세요",
  "account.name": "계정명",
  "account.newPassword": "새 비밀번호",
  "account.confirmNewPassword": "새 비밀번호 확인",
  "account.nameTips": "계정명을 입력하세요",
  "account.passwordModifySuccess": "비밀번호 변경 성공",
  "account.emailCode": "이메일 인증 코드",
  "account.emailCodeTips": "이메일 인증 코드를 입력하세요",
  "account.emailCodeTips2": "유효하지 않은 이메일 인증 코드",
  "account.emailModifySuccess": "비밀번호 변경 성공",
  "account.passworTips1": "귀하의 비밀번호가 복구되었습니다!",
  "account.passwordTips11": "비밀번호를 확인하기 위해 입력하세요",
  "account.passwordTips12": "새 비밀번호를 입력하세요",
  "account.nickname": "닉네임",
  "account.modifyNickname": "닉네임 변경",
  "account.modifyNicknameSuccess": "닉네임 변경 성공!",
  "account.nicknameTips": "닉네임을 입력하세요",
  "account.nicknameError": "닉네임 변경 실패!",

  // 빠른 회원가입 및 로그인
  "account.login": "로그인",
  "account.quickRegister": "빠른 회원가입",
  "account.sendCode": "인증 코드 전송",
  "account.sendTips": "s초 후 다시 전송할 수 있습니다",
  "account.sendEmailIng": "이메일 전송 중... 잠시만 기다려 주세요...",
  "account.emailNotEmpty": "이메일 필드는 비워둘 수 없습니다",
  "account.registerAccount": "계정 회원가입",
  "account.registerWelcome": "SusprSafe 회원가입에 오신 것을 환영합니다",
  "account.usernameLimit": "사용자명은 문자로 시작해야 하며, 문자, 숫자 및 밑줄(_)만 포함할 수 있고, 길이는 5-15자입니다",

  // 저작권 정보
  "copyright.desc2": "웹사이트 등록 정보: 광동성 ICP 등록번호 2021169764",

  // 사용자 정보 편집
  "editUserInfo.editUserInformation": "사용자 정보 편집",
  "editUserInfo.modifyUsername": "사용자명 변경",
  "editUserInfo.changePictures": "프로필 사진 변경",
  "editUserInfo.savePicturesSuccess": "프로필 사진 저장 성공",
  "editUserInfo.saveError": "저장 실패",
  "editUserInfo.pictureLimit": "사진 크기는 2MB를 초과할 수 없습니다",
  "editUserInfo.uploadPicture": "프로필 사진 업로드",
  "editUserInfo.picturePreview": "미리보기",
  
  "editUserInfo.bindPhoneNumber": "전화번호 바인딩",
  "editUserInfo.bindEmail": "이메일 바인딩",
  "editUserInfo.changePassword": "비밀번호 변경",

  "editUserInfo.notificationSettings": "알림 설정",
  "editUserInfo.editAccount": "계정 정보 편집",
  "editUserInfo.waitBingting": "바인딩 중... 잠시만 기다려 주세요...",
  "editUserInfo.collapse": "접기（분리）",
  "editUserInfo.modifyBinding": "바인딩 변경",
  
  "editUserInfo.emailAddress": "이메일 주소",
  "editUserInfo.tips1": "이메일 바인딩 성공",
  "editUserInfo.tips2": "저장 실패",
  "editUserInfo.tips3": "이메일 인증 코드 전송 중... 잠시만 기다려 주세요...",
  "editUserInfo.tips4": "인증 코드가 xxxx 이메일로 전송되었습니다, 확인하세요",
  "editUserInfo.tips5": "인증 코드 전송 실패!",
  "editUserInfo.tips6": "전화번호 바인딩 완료",
  "editUserInfo.tips7": "이메일 바인딩 완료",
  "editUserInfo.emailTips1": "이메일 주소를 입력하세요",
  "editUserInfo.emailTips2": "유효하지 않은 이메일 형식",
  "editUserInfo.emailTips3": "xxxx초 후 다시 전송할 수 있습니다",
  "editUserInfo.emailTips4": "인증 코드 전송",
  "editUserInfo.emailTips5": "이메일 인증 코드 필드는 비워둘 수 없습니다",
  "editUserInfo.emailTips6": "유효하지 않은 이메일 인증 코드",
  "editUserInfo.emailCode": "이메일 인증 코드",
  "editUserInfo.save": "저장",

  // 전화 바인딩 관련
  "editUserInfo.phoneTips1": "전화번호 바인딩 성공",
  "editUserInfo.phoneTips2": "SMS 인증 코드 전송 중... 잠시만 기다려 주세요...",
  "editUserInfo.phoneTips3": "SMS 인증 코드가 xxxx 번호로 전송되었습니다, 확인하세요",
  "editUserInfo.phoneTips4": "SMS 인증 코드 전송 실패!",
  "editUserInfo.phoneTips5": "전화번호를 입력하세요",
  "editUserInfo.phoneTips6": "유효하지 않은 전화번호 형식",
  "editUserInfo.phoneTips7": "SMS 인증 코드 전송",
  "editUserInfo.phoneTips8": "SMS 인증 코드",
  "editUserInfo.phoneTips9": "SMS 인증 코드 필드는 비워둘 수 없습니다",
  "editUserInfo.phoneTips10": "유효하지 않은 SMS 인증 코드",
  "editUserInfo.phone": "전화번호",


  // 알림 설정
  "editUserInfo.noticeTips1": "알림 설정 가져오기 실패!",
  "editUserInfo.noticeTips2": "알림 설정 저장 성공!",
  "editUserInfo.noticeTips3": "배터리 잔량 부족 알림",
  "editUserInfo.noticeTips4": "충전 완료 알림",
  "editUserInfo.errorNotification": "오류 알림",
  "editUserInfo.updateNotification": "업데이트 알림",
  "editUserInfo.monthlyStatisticsNotification": "월간 통계 알림",
  "editUserInfo.notificationMethod": "수신 방법",

  // 사용자명 관련 팁
  "editUserInfo.userNameTips1": "사용자명 저장 성공",
  "editUserInfo.userNameTips2": "사용자명 저장 실패",
  "editUserInfo.userNameTips3": "사용자명을 입력하세요",
  "editUserInfo.userNameTips4": "유효하지 않은 사용자명 형식: 숫자, 밑줄(_) 및 영문자만 포함할 수 있습니다",
  "editUserInfo.userNameTips5": "사용자명을 입력하세요",
  "editUserInfo.userNameTips6": "저장 중... 잠시만 기다려 주세요...",
  "editUserInfo.userName": "사용자명",

  // 프로필 사진 편집 팁
  "editUserInfo.avatorTips": "프로필 사진을 변경하려면 클릭하세요",
  "editUserInfo.verifyCodeTips1": "받은 인증 코드를 입력하세요:",
  "editUserInfo.verifyCodeTips2": "귀하의 계정 보안을 위해 아래 버튼을 클릭하여 원본 전화번호로 인증 코드를 전송하세요:",
  "editUserInfo.verifyCodeTips3": "인증 코드 전송",
  "editUserInfo.verifyCodeTips4": "원본 전화번호 인증 성공, 바인딩할 새 전화번호를 입력하세요",
  "editUserInfo.verifyCodeTips5": "귀하의 계정 보안을 위해 아래 버튼을 클릭하여 원본 이메일로 인증 코드를 전송하세요:",
  "editUserInfo.verifyCodeTips6": "원본 이메일 인증 성공, 새 이메일을 입력하세요",
  "editUserInfo.verifyCodeTips7": "이전 비밀번호",
  "editUserInfo.verifyCodeTips8": "먼저 이메일을 바인딩하세요!",
  "editUserInfo.verifyCodeTips9": "인증 코드가 이메일로 전송되었습니다, 확인하세요",
  "editUserInfo.verifyCodeTips10": "자동으로 로그인 페이지로 이동합니다",

  // 알림 관련
  "hems.notice.title": "알림 제목", 
  "hems.notice.content": "알림 내용", 
  "hems.notice.operate": "작업",
  "hems.notice.noRead": "읽지 않음",
  "hems.notice.read": "읽음",
  "hems.notice.warning": "경고",
  "hems.notice.error": "오류",
  "hems.notice.success": "통계 계산",
  "hems.notice.sys": "시스템 정보",
  "hems.notice.operateSuccess": "작업 성공",
  "hems.notice.operateTips": "작업할 항목을 선택하세요",

  // 홈페이지
  "hems.home.selfuseRate": "자가 이용률",
  "hems.home.percent": "퍼센트",
  "hems.home.todayData": "오늘의 데이터",
  "hems.home.todayPowerGeneration": "오늘의 발전량",
  "hems.home.salesIncome": "전력 판매 수입",
  "hems.home.saved": "절약한 금액",
  "hems.home.reduce": "탄소 배출량 감소",
  "hems.home.tips1": "현재 데이터를 사용할 수 없습니다, 아직 xxxx를 바인딩하지 않았습니다",
  "hems.home.criticalLoad": "크리티컬 부하",
  "hems.home.keyVoltage": "크리티컬 전압",
  "hems.home.householdLoad": "가정 부하",
  "hems.home.householdVoltage": "가정 전압",
  "hems.home.generalLoad": "일반 부하",
  "hems.home.generalVoltage": "일반 전압",
  "hems.home.batteryHealth": "배터리 건강 상태",
  "hems.home.averageTemp": "평균 온도",
  "hems.home.gridLoad": "전력망 부하",
  "hems.home.toggeleDataSource": "표시되는 데이터가 다음과 같이 변경되었습니다:",
  "hems.home.toggleTips": "변경하시겠습니까?",
  "hems.home.modeSending": "모드 명령 전송 중... 잠시만 기다려 주세요...",
  "hems.home.modeSuccess": "모드 변경이 성공적으로 전송되었습니다!",
  "hems.home.isOnline": "온라인 상태입니까?",
  "hems.home.useStatus": "사용 상태",
  "hems.home.workModeText": "현재 작업 모드:",
  "hems.home.toggleDataSourceText": "표시되는 데이터가 다음과 같이 변경되었습니다:",
  "hems.ev.charge.status": "충전 상태",
  "hems.ev.charge.time": "충전 시간",
  "hems.ev.charge.count": "실제 충전 횟수（시간 경과）",
  "hems.ev.charge.status.empty": "비어있음",
  "hems.ev.charge.status.ing": "배터리에 연결됨. 충전 중",
  "hems.ev.charge.status.null": "배터리에 연결됨, 하지만 충전 중이 아님",
  "hems.ev.charge.status.error": "오류",
  "hems.hour": "시간",
  "hems.minue": "분",
  "hems.ev.chagre.number": "충전기 번호",

  // 사용자 가이드
  "hems.userGuide.selfUse": "자가 발전 이용",
  "hems.userGuide.selfUseTips": "먼저 태양광 에너지를 사용하고, 부족한 경우 전력망으로 보충하세요",
  "hems.userGuide.economyMode": "경제 모드",
  "hems.userGuide.economyModeTips": "전기 요금에 기반한 에너지 사용 전략 최적화",
  "hems.userGuide.emergencyMode": "비상 모드",
  "hems.userGuide.emergencyModeTips": "크리티컬 부하에 대한 전력 공급 우선순위 설정",

  // 그래프 페이지
  "hems.history.energyStatistics": "에너지 통계",
  "hems.history.revenueStatistics": "수입 통계",
  "hems.history.greenStatistics": "그린 배출량 감소",
  "hems.history.revenueTitle": "전력 판매 총 수입",
  "hems.history.savingsTitle": "총 절약 금액",
  "hems.history.carbonTitle": "총 탄소 감소량",
  "hems.history.day": "일",
  "hems.history.month": "월",
  "hems.history.year": "년",
  "hems.history.beforeDay": "전일",
  "hems.history.afterDay": "익일",
  "hems.history.beforeMonth": "전월",
  "hems.history.afterMonth": "익월",
  "hems.history.beforeYear": "전년",
  "hems.history.afterYear": "익년",
  "hems.history.totalUse": "총 사용량",
  "hems.history.fullScreen": "전체 화면",
  "hems.history.timeSelect": "날짜 선택",
  "sync.tips1": "데이터 동기화 명령이 성공적으로 전송되었습니다!",
  "sync.tips2": "데이터 양이 많아 데이터 동기화에 시간이 걸립니다, 50분 후 다시 확인하세요~",
  "sync.tips3": "데이터 불일치가 발생하면 장치 데이터 동기화가 지연되었을 수 있으며, 아래 버튼을 클릭하세요:",
  "sync.tips4": "데이터 동기화",

  // 충전기 정보
  "charge.info": "충전기 정보",
  "news.loading": "로딩 중...",
  "news.noMore": "더 이상 데이터가 없습니다",
  "hems.pv.power": "태양광 에너지량",

  // UEH 특정 기능
  "ueh.sellPower": "판매 전력량",
  
  // 메뉴
  "menu.home": "홈페이지",
  "menu.history": "히스토리 데이터",
  "menu.device": "기기",
  "menu.settings": "설정",
  "menu.messageCenter": "메시지 센터",
  "menu.help": "도움말 및 지원",
  "menu.mine": "내 정보（개인）",


  // 내 설정
  "mine.userSetting": "사용자 설정",
  "mine.terminalSetting": "기본 단말 설정",
  "mine.uploadCloud": "데이터 클라우드 업로드",
  "mine.changeVersion": "업데이트 확인",
  "mine.language": "언어 변경",
  "mine.about": "앱 정보",
  "mine.feedback": "피드백",
  "mine.logout": "로그아웃",
  "mine.logoutAccount": "계정 삭제",

  // 계정 삭제 관련
  "mine.logoutAccountTips": "이름이 []인 계정 삭제",
  "mine.logoutAccountTips1": "[]에 바인딩된 계정 삭제",
  "mine.logoutAccountCare": "계정 삭제 요청 주의사항:",
  "mine.logoutAccountCare1": "1. 계정은 안전한 상태입니다",
  "mine.logoutAccountCare1-1": "계정은 정상 사용 상태이며, 도난, 규정 위반 또는 폐쇄 위험이 없습니다",
  "mine.logoutAccountCare2": "2. 계정 접근 권한 및 바인딩이 삭제됩니다",
  "mine.logoutAccountCare2-1": "제3자 플랫폼에 대한 모든 계정 접근 권한이 삭제됩니다",
  "mine.logoutAccountCare3": "3. 삭제 후 계정을 복구할 수 없으며, 사용자 데이터가 삭제됩니다",
  "mine.logoutAccountCare3-1": "삭제 후 바인딩된 전화번호, 이메일 및 관련 데이터가 삭제되어 복구할 수 없습니다",
  "mine.confirmLogout": "삭제 확인",
  "mine.logoutSuccess": "계정이 성공적으로 삭제되었습니다!",


  // 피드백 문제
  "mine.feedbackIssues": "문제 및 피드백",
  "mine.feedQuantity": "수량",
  "mine.feedAmount": "최대 9장의 이미지, 이미지 1장당 최대 크기 1MB",

  // 알림 설정 관련
  "mine.notice.fail": "알림 설정 가져오기 실패!",
  "mine.notice.saveSuccess": "알림 설정 저장 성공!",
  "mine.notice.saveFail": "저장 실패!",
  "mine.notice.title": "알림 설정",
  "mine.notice.batteryLow": "배터리 잔량 부족 알림",
  "mine.notice.chargingFinish": "충전 완료 알림",
  "mine.notice.error": "오류 알림",
  "mine.notice.update": "업데이트 알림",
  "mine.notice.monthly": "월간 통계 알림",
  "mine.notice.receiveType": "수신 방법",

  // 언어 설정 환영
  "mine.language.welcome": "SusprSafe에 오신 것을 환영합니다",
  "mine.language.desc1": "귀하의 집 주소에 따라 언어 버전을 선택하세요",
  "mine.language.desc2": "앱 설정에서 언제든지 변경할 수 있습니다",

  // 개인 정보
  "mine.userInfo.avatar": "프로필 사진",
  "mine.userInfo.nickname": "닉네임",
  "mine.userInfo.password": "비밀번호",
  "mine.userInfo.changePassword": "비밀번호 변경",
  "mine.userInfo.setPassword": "비밀번호 설정",
  "mine.userInfo.phoneNumber": "전화번호",
  "mine.userInfo.bindPhone": "전화 바인딩",
  "mine.userInfo.bindEmail": "이메일 바인딩",
  "mine.loginExpired": "로그인 세션이 만료되었습니다, 다시 로그인하세요",
  "mine.userInfo.title": "사용자 정보",
  "mine.userInfo.bind": "바인딩",
  "mine.userInfo.modify": "수정",
  "mine.userInfo.modifyNickname": "닉네임 변경",
  "mine.userInfo.userNickname": "사용자 닉네임",
  "mine.userInfo.selectPic": "업로드할 이미지를 선택하세요",
  "mine.userInfo.saveSuccess": "저장 성공",
  "mine.userInfo.uploadFail": "업로드 실패",
  "mine.userInfo.avatarSaveSuccess": "프로필 사진 저장 성공",
  "mine.userInfo.nameTips1": "닉네임 필드는 비워둘 수 없습니다",
  "mine.userInfo.nameTips2": "닉네임을 입력하세요",

  // 일반 선택 팁
  "common.pleaseSelect": "선택하세요",
  "question.commonQuestions": "자주 묻는 질문",
  "account.toggleLanguage": "언어 변경",
  "account.localConnection": "로컬 연결",
  "account.selectLanguage": "언어를 선택하세요",
  "account.sendEmailToast": "인증 코드가 xxx 이메일로 전송되었습니다, 확인하세요",
  "account.emailError": "유효하지 않은 이메일 형식",
  "account.sendEmailFail": "전송 실패, 다시 시도하세요",
  
  "common.submitting": "전송 중... 잠시만 기다려 주세요...",

  "device.page.noData": "현재 데이터를 사용할 수 없습니다, 이 페이지는 앱 내에서만 표시할 수 있습니다",

  // OTA Upgrade
  "bmsFirmware.upgrade": "업그레이드",
  "bmsFirmware.upgrading": "업그레이드 중...",
  "bmsFirmware.uploadingFile": "편웨어 파일 업로드 중...",
  "bmsFirmware.upgradingProgress": "편웨어 업그레이드 중... {progress}%",
  "bmsFirmware.upgradeSuccess": "업그레이드 성공",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS 편웨어 업그레이드 완료!",
  "bmsFirmware.upgradeFailed": "업그레이드 실패",
  "bmsFirmware.upgradeFailedFormError": "양식이 올바르게 작성되었는지 확인해 주세요",
  "bmsFirmware.upgradeFailedNetworkError": "네트워크 오류, 다시 시도해 주세요",
  "bmsFirmware.invalidFileType": "올바른 편웨어 파일을 선택해 주세요 (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "먼저 편웨어 파일을 선택해 주세요",
  "bmsFirmware.statusUpgrading": "업그레이드 중",
  "bmsFirmware.statusCompleted": "업그레이드 완료",
  "bmsFirmware.statusFailed": "업그레이드 실패",
  "bmsFirmware.deviceUpgrading": "편웨어 패키지 업그레이드 중, 업그레이드는 30~50분 소요되며, 이 기간 동안 실시간 장치 데이터를 보실 수 없습니다. 기다려 주세요...",
  "bmsFirmware.upgradeStatusLabel": "업그레이드 상태",
  "bmsFirmware.upgradeProgressLabel": "업그레이드 진행률",
  "bmsFirmware.currentPackageLabel": "현재 전송된 데이터 패키지 번호",
  "bmsFirmware.totalPackagesLabel": "총 데이터 패키지 수",
  "bmsFirmware.upgradeFailedCheckDevice": "장치 상태를 확인하고 업그레이드를 다시 시도해 주세요",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "설정 성공",
  "settingResult.defaultSubTitle": "매개변수 설정이 저장되었습니다",
  "settingResult.confirmButton": "OK"
};
